import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
  ButtonDropdown,
  Container,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";
import { Link } from "react-router-dom";
import { siteName, siteParams } from "../../config/site";
import Logo from "../Logo";

import IconLupa from "../../assets/images/icon-lupa.jpg";

import { Creators as SessionCreators } from "../../store/ducks/session";
import { Creators as SubscriptionCreators } from "../../store/ducks/subscription";

class Header extends Component {
  static propTypes = {
    invalidateSession: PropTypes.func.isRequired,
    user: PropTypes.shape.isRequired,
    getSubscriptionRequest: PropTypes.func.isRequired,
    subscription: PropTypes.shape.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      dropdownOpen: false
    };
  }

  componentWillMount() {
    if (this.props.user.id) {
      this.props.getSubscriptionRequest(this.props.user.id);
    }
  }

  toggleNavbar = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  };

  logout = e => {
    e.preventDefault();
    this.props.invalidateSession();
  };

  render() {
    return (
      <Container className="mb-4">
        <Navbar color="white" light expand="md">
          <NavbarBrand href="/">
            <Logo height="50px" />
          </NavbarBrand>

          <NavbarToggler onClick={this.toggleNavbar} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {false && (
                <NavItem>
                  <Link className="nav-link" to="/jornais/todos">
                    Jornais
                  </Link>
                </NavItem>
              )}
              <NavItem>
                <Link className="nav-link" to="/download-app">
                  Baixar o App
                </Link>
              </NavItem>
              {!this.props.subscription.data.id &&
                ["bebanca", "begamer"].includes(siteName) && (
                  <NavItem>
                    <a className="nav-link" href="/credit-card">
                      Assine
                    </a>
                  </NavItem>
                )}
              {!this.props.subscription.data.id &&
                !["bebanca", "begamer"].includes(siteName) && (
                  <NavItem>
                    <a className="nav-link" href={siteParams.assinatura.url}>
                      Assine
                    </a>
                  </NavItem>
                )}
              {!this.props.user.id && (
                <NavItem>
                  <Link className="nav-link" to="/signin">
                    Entrar
                  </Link>
                </NavItem>
              )}

              {this.props.user.id && (
                <NavItem className="ml-3 mr-3 mt-1">
                  <ButtonDropdown
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggleDropdown}
                    className="ml-auto"
                    id="logged-menu"
                  >
                    <DropdownToggle caret>
                      {this.props.user.nickname}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem>
                        <NavLink href="/admin">Minha Conta</NavLink>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem>
                        <NavLink href="/admin/sair" onClick={this.logout}>
                          Sair
                        </NavLink>
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </NavItem>
              )}
              {false && (
                <NavItem>
                  <Form action="/jornais/todos" method="get">
                    <div className="input-group">
                      <input
                        name="q"
                        className="form-control border-right-0 border"
                        type="search"
                        placeholder="Buscar..."
                        id="example-search-input"
                      />
                      <span className="input-group-append">
                        <button className="border-left-0 border">
                          <img
                            src={IconLupa}
                            alt=""
                            title=""
                            width="37"
                            height="37"
                          />
                        </button>
                      </span>
                    </div>
                  </Form>
                </NavItem>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  subscription: state.subscription.subscription
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...SessionCreators, ...SubscriptionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js